import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import InvoiceListItem from "./InvoiceListItem";
import {getClassNamesForThButton, useSortableData, alphabetizeByAttributeReverse} from "../common/Helpers";
import {getInvoices, clearInvoices, getInvoicesOfProject} from "../../actions/invoices";


export function InvoiceList(props) {

    const invoices = useSelector(state => state.invoices.invoices);
    const invoice = useSelector(state => state.invoices.invoice);
    const noInvoicesExist = useSelector(state => state.invoices.noInvoicesExist);
    const auth = useSelector(state => state.auth);
    const contractDrop = useSelector(state => state.contract.contractDrop);
    const projectDrop = useSelector(state => state.projects.projectDrop);

    const [render, setRender] = useState(noInvoicesExist || invoices.length > 0);
    const [companyTitle, setCompanyTitle] = useState("To / From")
    const [companyClicks, setCompanyClicks] = useState(0);

    const relevantInvoices = contractDrop.contract_id
        ? invoices.filter(invoice => invoice.contract_id === contractDrop.contract_id)
        : (projectDrop.project_id 
            ? invoices.filter(invoice => invoice.project_id === projectDrop.project_id)
            : invoices)
    const orderedInvoices = alphabetizeByAttributeReverse(relevantInvoices, "date_created");
    const { items, requestSort, sortConfig } = useSortableData(orderedInvoices);
    const listResponsible = items.filter( (invoice) => (!invoice.party_responsible && invoice.invoice_status === "Draft") || (invoice.party_responsible && invoice.party_responsible.filter((party => party.user_id === auth.user.id)).length > 0 ));
    const listWait = items.filter( (invoice) => (!invoice.party_responsible && invoice.invoice_status !== "Draft") || (invoice.party_responsible && invoice.party_responsible.filter((party => party.user_id === auth.user.id)).length === 0 ));

    // Start rendering the component only once the list data is returned
    useEffect(() => {
        if (!render) {
            (noInvoicesExist || invoices.length > 0) && setRender(true);
        }
    }, [noInvoicesExist, invoices]);


    const handleDelete = (e, id, number) => {
        e.stopPropagation();
        props.deleteInvoice(id, number);
    }

    const handleSelectInvoiceListItem = (id, status) => {
        status === "Draft"
        ? props.history.push(`/mng/invoice/edit/${id}`)
        : props.history.push(`/mng/invoice/view/${id}`);
    }

    const toggleCompanySort = () => {
        if (companyClicks < 2 || companyClicks === 4) {
            requestSort("purchaser_name")
        } else {
            requestSort("vendor_name")
        }
        companyClicks === 4 
        ? setCompanyClicks(1)
        : setCompanyClicks(companyClicks + 1);
    }

    const toggleSortOther = (key) => {
        setCompanyClicks(0);
        requestSort(key);
    }

    useEffect(() => {
        // unless toggling away, set company heading
        if (companyClicks > 0) {
            if (companyClicks < 3) {
                setCompanyTitle("To / From")
            } else {
                setCompanyTitle("From / To")
            }
        }
    }, [companyClicks])

    const sortByCompany = companyTitle === "Purchaser / Vendor" ? "Purchaser" : "Vendor"
    const companyClass = (sortConfig?.key === "purchaser_name" || sortConfig?.key === "vendor_name") ? sortConfig?.direction : "";

    const noResults = 
        <div className="page-card narrow light-black g5-text" >
            You have no invoices yet
            {(projectDrop.project_id && contractDrop.contract_id) && <>&nbsp;for <span className="heavy">{contractDrop.contract_name?.length > 0 ? contractDrop.contract_name : "this contract"}</span></>}
            {(projectDrop.project_id && !contractDrop.contract_id) && <>&nbsp;for project <span className="heavy">{projectDrop.project_name?.length > 0 ? projectDrop.project_name : "this project"}</span></>}
            .
        </div>

    const invoiceTable = 
        <table className="card-table">
            <thead>
                <tr>
                    <th className="content2 heavy-grey flexi first" colSpan="2" >
                        <button type="button" onClick={() => toggleSortOther("invoice_number")} className={getClassNamesForThButton("invoice_number", sortConfig)} >
                            Invoice Number
                        </button>
                    </th>
                    <th className="content2 heavy-grey flexi" style={{width: "18%"}} >
                        <button type="button" onClick={() => toggleCompanySort()} className={companyClass} >
                            {companyTitle}
                        </button>
                    </th>
                    <th className="content2 heavy-grey flexi" style={{width: "18%"}} >
                        <button type="button" onClick={() => toggleSortOther("send_date")} className={getClassNamesForThButton("send_date", sortConfig)} >
                            Sent
                        </button>
                    </th>
                    <th className="content2 heavy-grey flexi" style={{width: "18%"}} >
                        <button type="button" onClick={() => toggleSortOther("payment_due_date")} className={getClassNamesForThButton("payment_due_date", sortConfig)} >
                            Payment Due
                        </button>
                    </th>
                    <th className="content2 heavy-grey flexi" style={{width: "10%"}} >
                        <button type="button" onClick={() => toggleSortOther("total_value")} className={getClassNamesForThButton("total_value", sortConfig)} >
                            Total Value
                        </button>
                    </th>
                    <th className="content2 heavy-grey rigid last-cell" colSpan="1">
                        <button type="button" onClick={() => toggleSortOther("invoice_status")} className={getClassNamesForThButton("invoice_status", sortConfig)} >
                            Current Step
                        </button>
                    </th>
                </tr>
            </thead>
            <tbody id="section1">
                {listResponsible.length > 0 && <tr><th className="content3 p4-text p8b action-header" colSpan="8" >ACTION REQUIRED</th></tr>}
                {listResponsible.map((invoice) => {
                    return(
                        <InvoiceListItem responsible={true} invoice={invoice} key={invoice.invoice_id} handleDelete={handleDelete} action="act" handleSelectInvoiceListItem={handleSelectInvoiceListItem} sortByCompany={sortByCompany} />
                    )
                })}
            </tbody>
            <tbody id="section2">
                {listWait.length > 0 && <tr><th className="content3 g3-text g8 action-header" colSpan="8" >NO ACTION REQUIRED</th></tr>}
                {listWait.map((invoice) => {
                    return(
                        <InvoiceListItem invoice={invoice} key={invoice.invoice_id} handleDelete={handleDelete} action="wait" handleSelectInvoiceListItem={handleSelectInvoiceListItem} sortByCompany={sortByCompany} />
                    )
                })}
            </tbody>
        </table>

        return (
            <>{render &&
                <div className="table-wrapper">
                    {relevantInvoices.length > 0 ? invoiceTable : noResults}
                </div> 
            }</>
        )
    }

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {getInvoices, clearInvoices, getInvoicesOfProject})(InvoiceList);